import { pluralize } from '@fourthwall/utils/dist/string'

import type { ProductsSyncStatus } from '../AppsTiktokShop.types'

export const getSyncedProductsHeading = (status: ProductsSyncStatus, productsLength: number) => {
  const headingLabelMap: Record<ProductsSyncStatus, string> = {
    active: 'synced to TikTok',
    pending: 'available to sync to TikTok',
    denied: 'not eligible for TikTok Shop',
  }

  return `${productsLength} ${pluralize(productsLength, 'product')} ${headingLabelMap[status]}`
}
